import { render, staticRenderFns } from "./BookmarkEditor.vue?vue&type=template&id=230d8730&scoped=true&"
import script from "./BookmarkEditor.vue?vue&type=script&lang=ts&"
export * from "./BookmarkEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkEditor.vue?vue&type=style&index=0&id=230d8730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d8730",
  null
  
)

export default component.exports